export enum ZzimButtonType {
  STORE = 'store',
  PRODUCT = 'product',
  DESIGNER = 'designer',
  FASHION_BRAND = 'fashionBrand',
  RELATED_PRODUCT_STORE = 'related_product_store',
}

export enum ZzimErrorCode {
  ALREADY_ZZIMED = '1004',
  AGE_RESTRICTION = '1002',
  INERNAL_ERROR = '1123',
  SALE_SUSPENSION = '1001',
}

export const isAlreadyDoneError = (errorCode: ZzimErrorCode) => [ZzimErrorCode.ALREADY_ZZIMED].includes(errorCode)

export const resolveZzimErrorMessage = (errorCode: ZzimErrorCode, zzimed: boolean, message: string) => {
  if (
    [ZzimErrorCode.ALREADY_ZZIMED, ZzimErrorCode.AGE_RESTRICTION, ZzimErrorCode.SALE_SUSPENSION].includes(errorCode)
  ) {
    return message
  }
  return `${zzimed ? '찜 해제' : '찜 하기'}에 실패했습니다.`
}
